import Tag from '@/shared/models/Tag';
import AbstractTask from './AbstractTask';
import Appointment from './Appointment';

export default class AssignedDossierTask extends AbstractTask {
  isWaitingForCheckIn = false;
  tags: Array<Tag> = [];
  appointment!: Appointment;
}
